import { render, staticRenderFns } from "./CreateAnAccount.vue?vue&type=template&id=245116a4&"
import script from "./CreateAnAccount.vue?vue&type=script&lang=js&"
export * from "./CreateAnAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports